import React, { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import Constants from "../../data/Constants";
import Utils from "../../utils";
import Chart from "react-apexcharts";
import moment from "moment";
import {
  getClassList,
  getSingleClass,
  transferClass,
} from "services/classes.service";
import { getSingleStudent } from "services/user.service";
import { getCoursesList } from "services/course.service";
import { Button, MenuItem, TextField } from "@mui/material";
import * as yup from "yup";
import { useFormik } from "formik";

function TransferClass(props) {
  const { setProgress, setToast } = useOutletContext();
  const navigate = useNavigate();
  const { fromClassId, studentId } = useParams();

  const [fromClass, setFromClass] = useState();
  const [fromCourse, setFromCourse] = useState();
  const [classes, setClasses] = useState([]);
  const [courses, setCourses] = useState([]);
  const [student, setStudent] = useState();

  const validationSchema = yup.object({});

  const formik = useFormik({
    initialValues: { courseClass: "" },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      console.log(values);
      formSubmitHandler(values);
    },
  });

  const formSubmitHandler = async (values) => {
    try {
      setProgress(true);
      const res = await transferClass({
        studentId: student._id,
        fromClass: fromClass._id,
        toClass: values.courseClass,
      });

      setProgress(false);

      setToast({
        success: true,
        message: "Class Transfer Successfull",
      });

      navigate("/dashboard/classes/students/" + values.courseClass);
    } catch (error) {
      setProgress(false);
      setToast({ error: true, message: Utils.CustomErrorMessage(error) });
    }
  };

  useEffect(() => {
    async function api() {
      setProgress(true);
      try {
        const fromClassRes = await getSingleClass(fromClassId);
        const studentRes = await getSingleStudent(studentId);
        const coursesRes = await getCoursesList({
          type: [
            Constants.Course.Type.LIVE_SINGLE,
            Constants.Course.Type.LIVE_GROUP,
          ],
        });

        setFromClass(fromClassRes);
        setStudent(studentRes);
        setCourses(coursesRes);
        setProgress(false);
      } catch (error) {
        // error
        console.log(error);
        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }
    api();
  }, []);

  useEffect(() => {
    if (courses && fromClass) {
      const course = courses.find((val) => val._id == fromClass.course);
      setFromCourse(course);
    }
  }, [fromClass, courses]);

  useEffect(() => {
    async function api() {
      setProgress(true);
      try {
        const classRes = await getClassList({
          course: fromCourse._id,
        });
        if (classRes) {
          setClasses(classRes.filter((val) => val._id != fromClass._id));
          setProgress(false);
        } else {
          // error
          setProgress(false);
          setToast({ error: true, message: Constants.Error.UNKNOWN });
        }
      } catch (error) {
        // error
        console.log(error);
        setProgress(false);
        setToast({
          error: true,
          message: Utils.CustomErrorMessage(error),
        });
      }
    }

    if (fromCourse) {
      api();
    }
  }, [fromCourse]);

  return (
    <>
      {student && fromClass && fromCourse && (
        <form
          className="flex flex-col gap-4 my-6"
          onSubmit={formik.handleSubmit}
        >
          <div className="text-2xl font-bold my-6">Reschedule Class</div>

          <div>
            Student: <b>{student.firstname + " " + student.lastname}</b>
          </div>
          <div>
            From Class :{" "}
            <b>{fromCourse.name + " - BATCH " + fromClass.batchNumber}</b>
          </div>

          <div>
            <div className="mb-4">To Class :</div>
            <TextField
              variant="filled"
              size="small"
              name="courseClass"
              label="Select Class"
              value={formik.values.courseClass}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.courseClass && Boolean(formik.errors.courseClass)
              }
              helperText={
                formik.touched.courseClass && formik.errors.courseClass
              }
              required
              fullWidth
              select
            >
              {classes.map((option, index) => {
                return (
                  <MenuItem
                    key={index}
                    value={option._id}
                    disabled={option.bookedSeats == option.totalSeats}
                  >
                    BATCH - {option.batchNumber} ({option.bookedSeats}/
                    {option.totalSeats} Seats)
                    {option.bookedSeats == option.totalSeats && " (All Booked)"}
                  </MenuItem>
                );
              })}
            </TextField>
          </div>

          <Button type="submit" variant="contained">
            Reschedule Class
          </Button>
        </form>
      )}
    </>
  );
}
export default TransferClass;
